import axios from 'axios';
import authHeader from './auth-header';

//const API_URL = 'http://localhost:8080/matrix-mlm/api/mlm/mapv/';
const API_URL = 'https://www.edibleherbsstores.com/api/mlm/mapv/';

class MonthlyActivationPvService {
  getAll() {
    return axios.get(API_URL + `monthlyactivationpv/all`, { headers: authHeader() });
  }

  get(id) {
    return axios.get(API_URL + `monthlyactivationpv/${id}`, { headers: authHeader() });
  }

  create(monthlyActivationPv) {
    return axios.post(API_URL + `monthlyactivationpv/cre`, {
      memberId: monthlyActivationPv.memberId,
      monthlyActivationDate: monthlyActivationPv.monthlyActivationDate,
      level: monthlyActivationPv.level,
      paidStatus: monthlyActivationPv.paidStatus
    }, { headers: authHeader() });
  }

  update(id, monthlyActivationPv) {
    return axios.put(API_URL + `monthlyactivationpv/${id}/upd`, {
      id: monthlyActivationPv.id,  
      memberId: monthlyActivationPv.memberId,
      monthlyActivationDate: monthlyActivationPv.monthlyActivationDate,
      level: monthlyActivationPv.level,
      paidStatus: monthlyActivationPv.paidStatus
    }, { headers: authHeader() });
  }

  updateMonthlyActivationPvTablePaidStatus(memberId, paidStatus) {
    return axios.put(API_URL + `monthlyactivationpv/${memberId}/${paidStatus}/updpaidstatus`, {
      memberId: memberId,
      paidStatus: paidStatus
    }, { headers: authHeader() });
  }

  delete(id) {
    return axios.delete(API_URL + `del/${id}`, { headers: authHeader() });
  }

  deleteAll() {
    return axios.delete(API_URL + `delall`, { headers: authHeader() });
  }

  getMonthlyActivationPvsByMemberId(memberId) {
    return axios.get(API_URL + `monthlyactivationpv/${memberId}/member`, { headers: authHeader() });
  }

  getMonthlyActivationPvsByPaidStatus() {
    return axios.get(API_URL + `monthlyactivationpv/paidstatus`, { headers: authHeader() });
  }
  
  getMonthlyActivationPvsByMaDateAndPaidStatus(monthlyActivationDate) {
    return axios.get(API_URL + `monthlyactivationpv/${monthlyActivationDate}/madateandpaidstatus`, { headers: authHeader() });
  }
  
  getMonthlyActivationPvsCountByPaidStatus() {
    return axios.get(API_URL + `monthlyactivationpv/paidstatuscount`, { headers: authHeader() });
  }
  
  getMonthlyActivationPvsCountByDate(monthlyActivationDate) {
    return axios.get(API_URL + `monthlyactivationpv/${monthlyActivationDate}/madatecount`, { headers: authHeader() });
  }

  getMonthlyActivationPvByLevel(level) {
    return axios.get(API_URL + `monthlyactivation/${level}/mapvbylevel`, { headers: authHeader() });
  }

  getMonthlyActivationPvs(memberId) {
    return axios.get(API_URL + `monthlyactivationpv/${memberId}/mapvsbymember`, { headers: authHeader() });
  }

  getTotalMaPv(memberId) {
    return axios.get(API_URL + `monthlyactivation/${memberId}/totalmapv`, { headers: authHeader() });
  }

  getTotalPaidMaPv(memberId) {
    return axios.get(API_URL + `monthlyactivation/${memberId}/totalpaidmapv`, { headers: authHeader() });
  }

  getMonthlyActivationPvsInfo(page, pageSize) {
    return axios.get(API_URL + `monthlyactivationpv/info?page=${page}&size=${pageSize}`, { headers: authHeader() });
  }

  getTotalMonthlyActivationPvs() {
    return axios.get(API_URL + `monthlyactivationpv/totalmonthlyactivationpvs`, { headers: authHeader() });
  }

  calculateActivationData() {
    return axios.get(API_URL + `monthlyactivationpv/calculateactivationdata`, { headers: authHeader() });
  }

  calculatePreviousActivation(month, year) {
    return axios.get(API_URL + `monthlyactivationpv/${month}/${year}/calculatepreviousactivation`, { headers: authHeader() });
  }

  calculateMonthlyActivation(month, year) {
    return axios.get(API_URL + `monthlyactivationpv/${month}/${year}/calculatemonthlyactivation`, { headers: authHeader() });
  }

  calculateActivationPayment(month, year) {
    return axios.get(API_URL + `monthlyactivationpv/${month}/${year}/calculateactivationpayment`, { headers: authHeader() });
  }

}

export default new MonthlyActivationPvService();